<template>
  <div class="">
    <img
      :src="require('@/assets/about/combanner.png')"
      alt="Carousel Image"
      style="display: inline-block; width: 100%"
    />
    <!-- 面包屑 -->
    <!-- <div class="x-help-bread">
      首页 <i class="el-icon-arrow-right x-help-icon"></i> 
      公司概述
    </div> -->
    <!-- 公司简介 -->
    <div class="comp">
      <div class="comp-title">公司简介</div>
      <div class="comp-box">
        <img
          :src="require('@/assets/about/comsmall.png')"
          alt="Carousel Image"
          style="display: inline-block; width: 100%"
        />
        <div class="comp-small-title">九驰快递简介</div>
        <div class="comp-content">
          九驰供应链（河南）有限公司成立于2023年02月15日，注册地位于河南省郑州市新郑市郭店镇新郑路与密杞路交叉口西北角五里口停车场院内A区1库1号，法定代表人为魏向生。经营范围包括许可项目：道路货物运输（不含危险货物）一般项目：道路货物运输站经营；国内集装箱货物运输代理；国内货物运输代理；普通货物仓储服务（不含危险化学品等需许可审批的项目）；国际货物运输代理；装卸搬运。
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
.x-help-bread {
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  background: #00AECF ;
  box-sizing: border-box;
  padding-left: 10%;
  color: #fff;
  font-size: 14px;
  .x-help-icon {
    padding: 0 5px;
    margin-top: 3px;
  }
}
.comp {
  width: 80%;
  margin: 0 auto;
  min-width: 1200px;
  .comp-title {
    width: 100%;
    font-size: 36px;
    height: 120px;
    line-height: 120px;
    text-align: center;
    font-weight: bold;
  }
  .comp-box {
    width: 100%;
    box-sizing: border-box;
    padding: 40px;
    background: #fff;
    margin-bottom: 40px;
    border-radius: 8px;
    .comp-small-title {
      margin-top: 20px;
      font-size: 16px;
      font-weight: bold;
      color: #00AECF ;
      text-align: left;
      line-height: 32px;
    }
    .comp-content {
      width: 100%;
      font-size: 14px;
      text-align: left;
      line-height: 20px;
    }
  }
}
</style>